import script from "./ThemeToggle.vue?vue&type=script&setup=true&lang=ts"
export * from "./ThemeToggle.vue?vue&type=script&setup=true&lang=ts"

import "./ThemeToggle.vue?vue&type=style&index=0&id=e28d1ad0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e28d1ad0"]])

export default __exports__